import { PAYMENT_API } from '~/lib/constants';

export function getApiPath(path: string): string {
  return `${PAYMENT_API}/${path}`;
}
